import microTemplate from 'micro-template.lib';
import {htmlentities, htmldecode} from 'String.util';

microTemplate.encodeHtml = htmlentities;
microTemplate.decodeHtml = htmldecode;

export default microTemplate;
